/* src/app/shared/components/pgc-custom-buttons/pgc-custom-buttons.component.css */
.pgc-custom-buttons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 8px 0;
}
.pgc-custom-buttons-modal-content {
  padding: 8px 0;
}
.pgc-custom-buttons-modal-description {
  margin-bottom: 16px;
  color: var(--color-neutral-dark-70, #4a5568);
  font-size: 14px;
}
.pgc-custom-buttons-modal-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.pgc-custom-buttons-modal-option {
  display: flex;
  align-items: center;
  gap: 12px;
}
.pgc-custom-buttons-option-desc {
  font-size: 13px;
  color: var(--color-neutral-dark-50, #718096);
}
/*# sourceMappingURL=pgc-custom-buttons.component.css.map */
